let route = {
    path: '/modules/orderPd',
    name: 'order-pd',
    component: () => import('@/modules/order-pd/index.vue'),
    children: [
        {
            path: 'order',
            name: 'order-management',
            component: () => import('@/modules/order-pd/order.vue'),
            meta: {
                pageTitle: '客户订单',
            }
        },
        {
            path: 'orderPdDetail',
            name: 'order-management-detail',
            component: () => import('@/modules/order-pd/orderDetail/index.vue'),
            meta: {
                parent: '/modules/order-pd/order',
            }
        }
    ],
    meta: {
        role: 'xurui_admin'
    }
};
export const OrderPdRouter = route;
